import VueRouter, { RouteConfig } from 'vue-router'

const ClassRoomIndex = () => import('../views/classroom-drill/Index.vue')
const ClassRoomAttendStudents = () => import('../views/classroom-drill/AttendStudents.vue')
const ClassRoomRecords = () => import('../views/classroom-drill/ClassRecords.vue')

// 随堂测试
export const classRoomRoute: RouteConfig = {
  path: '/classroom-drill/index',
  name: 'classroom_drill_index',
  component: ClassRoomIndex,
  meta: {
    title: '随堂测试',
  },
}

export const classRoomAttendStudentsRoute: RouteConfig = {
  path: '/classroom-drill/attend-students',
  name: 'classroom_drill_attend_students',
  component: ClassRoomAttendStudents,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '随堂测试',
  },
}

export const classRoomRecordsRoute: RouteConfig = {
  path: '/classroom-drill/records',
  name: 'classroom_drill_records',
  component: ClassRoomRecords,
  meta: {
    title: '随堂测试',
  },
}

export default [classRoomRoute, classRoomAttendStudentsRoute, classRoomRecordsRoute]
